// import React, { useState } from 'react';
// import { Mail, Linkedin, Globe, Phone } from 'lucide-react';

// const TeamMember = ({ member, isHovered, onHover, onLeave }) => {
//   return (
//     <div
//       className="group cursor-pointer"
//       onMouseEnter={onHover}
//       onMouseLeave={onLeave}
//     >
//       <div
//         className={`
//           relative overflow-hidden rounded-2xl bg-white shadow-lg
//           transition-all duration-500 ease-out
//           ${isHovered ? 'shadow-2xl scale-105' : 'shadow-md hover:shadow-xl'}
//         `}
//         style={{ background: 'white' }}
//       >
//         <div className="relative h-64 overflow-hidden">
//           <img
//             src={member.image}
//             alt={member.name}
//             className={`
//               w-full h-full object-cover transition-all duration-500
//               ${isHovered ? 'brightness-110 scale-110' : 'brightness-100'}
//             `}
//           />
//           <div
//             className={`
//               absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent
//               opacity-0 transition-opacity duration-500
//               ${isHovered ? 'opacity-100' : ''}
//             `}
//           />
//         </div>

//         <div className="p-6">
//           <h3
//             className={`
//               font-bold text-[#2f4f2f] transition-all duration-300
//               ${isHovered ? 'text-2xl mb-1' : 'text-xl mb-1'}
//             `}
//             style={{ fontFamily: "'Lora', serif" }}
//           >
//             {member.name}
//           </h3>

//           <p
//             className={`
//               text-sm font-medium text-[#228b22] mb-3 transition-all duration-300
//               ${isHovered ? 'opacity-100' : 'opacity-80'}
//             `}
//             style={{ fontFamily: "'Lora', serif" }}
//           >
//             {member.role}
//           </p>

//           <div
//             className={`
//               overflow-hidden transition-all duration-500 ease-out
//               ${isHovered ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}
//             `}
//           >
//             <p
//               className="text-sm text-gray-700 leading-relaxed mb-4 break-words"
//               style={{ fontFamily: "'Lora', serif" }}
//             >
//               {member.bio}
//             </p>

//             <div className="flex gap-3 justify-center flex-wrap">
//               {member.email && (
//                 <a href={`mailto:${member.email}`} className="p-2 rounded-full bg-[#2f4f2f] text-white hover:bg-[#1a2f1a] transition" aria-label="Email">
//                   <Mail className="w-4 h-4" />
//                 </a>
//               )}
//               {member.linkedin && (
//                 <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#0077b5] text-white hover:bg-[#005582] transition" aria-label="LinkedIn">
//                   <Linkedin className="w-4 h-4" />
//                 </a>
//               )}
//               {member.phone && (
//                 <a href={`tel:${member.phone}`} className="p-2 rounded-full bg-[#228b22] text-white hover:bg-[#1a6b1a] transition" aria-label="Phone">
//                   <Phone className="w-4 h-4" />
//                 </a>
//               )}
//               {member.website && (
//                 <a href={member.website} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#9acd32] text-[#2f4f2f] hover:bg-[#7fa828] transition" aria-label="Website">
//                   <Globe className="w-4 h-4" />
//                 </a>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Card = ({ title, content, isHovered, onMouseEnter, onMouseLeave }) => {
//   return (
//     <div
//       className={`
//         bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-500 ease-in-out
//         cursor-pointer
//         ${isHovered ? 'scale-105 shadow-2xl' : 'hover:shadow-xl'}
//       `}
//       style={{ minHeight: isHovered ? 'auto' : '140px' }}
//       onMouseEnter={onMouseEnter}
//       onMouseLeave={onMouseLeave}
//     >
//       <div className="p-8">
//         <div className="mb-6">
//           <h2
//             className="text-xl font-medium tracking-[0.05em] uppercase"
//             style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
//           >
//             {title}
//           </h2>
//         </div>

//         <div
//           className={`
//             transition-all duration-500 ease-in-out overflow-hidden
//             ${isHovered ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'}
//           `}
//         >
//           <p className="text-gray-700 leading-relaxed text-base break-words" style={{ fontFamily: "'Lora', serif" }}>
//             {content}
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// const AboutUs = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [hoveredMember, setHoveredMember] = useState(null);

//   const team = [
//     {
//       id: 'ceo',
//       name: 'Mugabe Robert',
//       role: 'CEO & Senior Travel Consultant',
//       image: 'https://www.uganda-safaris-tours.com/ug/img/team/robert1.jpg',
//       bio: 'With over 15 years in African safaris, Mugabe leads with passion and deep local knowledge. He personally joins select groups to ensure perfection.',
//     },
//     {
//       id: 'global',
//       name: 'Tobias Kimmich',
//       role: 'Global Travel Expert, Germany',
//       image: 'https://www.adventure-travellers.com/imgs/aat-images/tobias-kimmich-global-travel-expert-at-african-adventure-travellers.jpg',
//       bio: 'Based in Germany, Tobias connects international travelers with authentic Tanzanian experiences. Fluent in 4 languages.',
//     },
//     {
//       id: 'local',
//       name: 'Barak Chuwa',
//       role: 'Senior Travel Expert, Tanzania',
//       image: '/Pale.jpg',
//       bio: 'Born in Moshi, Barak knows every trail in Kilimanjaro and Serengeti. A certified safari guide with 12+ years of field expertise.',
//     },
//     {
//       id: 'it',
//       name: 'Dumba Bejamin',
//       role: 'IT Manager',
//       image: 'https://www.adventure-travellers.com/imgs/dumba.jpg',
//       bio: 'Dumba ensures seamless booking systems and 24/7 digital support. He’s the tech backbone behind your smooth safari planning.',
//     },
//     {
//       id: 'assistant',
//       name: 'Namara Racheal',
//       role: 'IT Assistant',
//       image: 'https://www.adventure-travellers.com/imgs/WhatsApp%20Image%202025-09-26%20at%2015.34.39_963c5576.jpg',
//       bio: 'Racheal supports clients with real-time updates, WhatsApp bookings, and instant responses. Always smiling, always helpful.',
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-white">
//       {/* HERO — NOW FULLY CONSISTENT WITH ALL PARAGRAPHS */}
//       <div className="py-16 px-0 md:px-12">
//         <div className="max-w-6xl mx-auto">
//           <div className="mb-8 text-center">
//             <h1
//               className="text-5xl md:text-6xl font-bold mb-4"
//               style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
//             >
//               TANZANIA YETU
//             </h1>
//             <p
//               className="text-2xl md:text-3xl font-medium mb-6"
//               style={{ color: '#228b22', fontFamily: "'Lora', serif" }}
//             >
//               OUR TANZANIA, YOUR ADVENTURE
//             </p>
//           </div>

//           {/* UNIFORM PARAGRAPH STYLE — SAME AS ALL OTHERS */}
//           <div className="text-gray-700 leading-relaxed text-base md:text-lg" style={{ fontFamily: "'Lora', serif" }}>
//             <p className="mb-5">
//               Welcome to Tanzania Yetu, where "Yetu" means "ours" in Swahili. We believe Tanzania belongs to all of us – its breathtaking wildlife, majestic landscapes, rich cultures, and warm people. As your trusted tourism partner, we're passionate about sharing the authentic beauty and wonder of Tanzania with the world.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* ABOUT US – AFRICAN ADVENTURE TRAVELLERS LTD */}
//       <section className="py-8 px-6 md:px-12 bg-white">
//         <div className="max-w-6xl mx-auto">
//           <h2
//             className="text-3xl md:text-4xl font-bold mb-4 text-center uppercase"
//             style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
//           >
//             ABOUT US – AFRICAN ADVENTURE TRAVELLERS LTD
//           </h2>

//           <p className="text-sm text-gray-600 text-center mb-6 italic" style={{ fontFamily: "'Lora', serif" }}>
//             LICENSED BY THE GOVERNMENT OF UGANDA (MINISTRY OF TOURISM & TRADE) MEMBER OF AUTO – ASSOCIATION OF UGANDA TOUR OPERATORS
//           </p>

//           <div className="space-y-5 text-gray-700 leading-relaxed text-base md:text-lg" style={{ fontFamily: "'Lora', serif" }}>
//             <p>
//               African Adventure Travellers Ltd is a proudly Ugandan tour company offering authentic, high-quality, and affordable safaris across Uganda, Tanzania, and East Africa. We connect travellers with Africa’s wildlife, landscapes, and cultures through memorable and responsible travel experiences.
//             </p>

//             <p>
//               We specialize in custom safaris and adventures, including gorilla and chimp trekking, wildlife game drives, birding, hiking, cultural tours, and adventure activities such as rafting, kayaking, horseback riding, and fishing trips.
//             </p>

//             <p>
//               Our safaris extend to Zanzibar, featuring iconic destinations like the Serengeti, Ngorongoro Crater, Lake Manyara, and Zanzibar, offering travellers unforgettable encounters with wildlife and nature. Our mission is to provide personalized, safe, and sustainable journeys that leave lasting memories and showcase the true spirit of East Africa.
//             </p>

//             <h3
//               className="text-2xl font-bold mt-8 mb-3 uppercase"
//               style={{ color: '#228b22', fontFamily: "'Lora', serif" }}
//             >
//               OUR TEAM – THE HEART OF AFRICAN ADVENTURE TRAVELLERS
//             </h3>

//             <p>
//               At African Adventure Travellers Ltd, our strength lies in our dedicated and experienced team professionals who share a deep passion for wildlife, travel, and authentic African hospitality.
//             </p>

//             <p>
//               With years of experience in organizing successful safaris and tours, our travel consultants work closely with each client to design and customize itineraries that perfectly match their travel dreams, budget, and schedule. From your first inquiry to the end of your journey, you’ll be guided by experts who understand every corner of Uganda and East Africa.
//             </p>

//             <p>
//               Upon arrival, our Safari Representatives will warmly welcome you at the airport (or at your hotel/residence upon request), brief you about your safari, and ensure every detail is well-coordinated. Once your adventure begins, your personal driver-guide will accompany you throughout the trip, ensuring comfort, safety, and unforgettable memories on the road.
//             </p>

//             <p>
//               At African Adventure Travellers, your safety and satisfaction come first. Every team member, from the office to the field, is committed to delivering exceptional service and genuine care that makes you feel at home while exploring the wild. Our guides are fluent in English and at least possess knowledge of local languages across East Africa, enabling smooth communication with communities and enhancing the authenticity of every safari experience.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* VISION, MISSION, VALUES */}
//       <section className="pt-8 pb-16 px-0 md:px-12">
//         <div className="max-w-6xl mx-auto">
//           <h2
//             className="text-4xl font-medium tracking-[0.05em] mb-6 text-center uppercase"
//             style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
//           >
//             WHAT DRIVES US FORWARD
//           </h2>

//           <p className="text-lg text-gray-700 mb-6 px-6 md:px-0">
//             Our commitment to excellence in Tanzania's tourism industry is built on three pillars that guide everything we do.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-6 md:px-0">
//             <Card
//               title="OUR VISION"
//               content="To be the leading destination management company in Tanzania, recognized globally for creating transformative safari and cultural experiences. We envision Tanzania as the world's premier eco-tourism destination, where conservation, community development, and authentic travel experiences converge to benefit both visitors and local communities for generations to come."
//               isHovered={hoveredCard === 'vision'}
//               onMouseEnter={() => setHoveredCard('vision')}
//               onMouseLeave={() => setHoveredCard(null)}
//             />
//             <Card
//               title="OUR MISSION"
//               content="To showcase Tanzania's extraordinary wildlife, stunning landscapes, and vibrant cultures through carefully crafted, sustainable tourism experiences. We connect travelers with the soul of Tanzania while supporting conservation efforts, empowering local communities, and preserving our natural heritage. Every journey we create tells Tanzania's story with authenticity, respect, and wonder."
//               isHovered={hoveredCard === 'mission'}
//               onMouseEnter={() => setHoveredCard('mission')}
//               onMouseLeave={() => setHoveredCard(null)}
//             />
//             <Card
//               title="OUR CORE VALUES"
//               content="Ubuntu (We are one) - fostering community connection; Mazingira (Environment) - protecting Tanzania's natural beauty; Utamaduni (Heritage) - celebrating local cultures; Ubora (Excellence) - delivering exceptional experiences; Uwazi (Transparency) - honest, ethical practices; Uongozi (Leadership) - pioneering sustainable tourism that benefits all stakeholders while creating memories that last a lifetime."
//               isHovered={hoveredCard === 'values'}
//               onMouseEnter={() => setHoveredCard('values')}
//               onMouseLeave={() => setHoveredCard(null)}
//             />
//           </div>
//         </div>
//       </section>

//       {/* TEAM SECTION — REDUCED TOP PADDING */}
//       <section className="py-12 px-6 md:px-12 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <h3
//             className="text-4xl font-medium tracking-[0.05em] mb-10 text-center uppercase"
//             style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
//           >
//             MEET OUR EXPERT TEAM
//           </h3>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
//             {team.map((member) => (
//               <TeamMember
//                 key={member.id}
//                 member={member}
//                 isHovered={hoveredMember === member.id}
//                 onHover={() => setHoveredMember(member.id)}
//                 onLeave={() => setHoveredMember(null)}
//               />
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default AboutUs;



import React, { useState } from 'react';
import { Mail, Linkedin, Globe, Phone } from 'lucide-react';

const TeamMember = ({ member, isHovered, onHover, onLeave }) => {
  return (
    <div
      className="group cursor-pointer"
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
    >
      <div
        className={`
          relative overflow-hidden rounded-2xl bg-white shadow-lg
          transition-all duration-500 ease-out
          ${isHovered ? 'shadow-2xl scale-105' : 'shadow-md hover:shadow-xl'}
        `}
        style={{ background: 'white' }}
      >
        <div className="relative h-64 overflow-hidden">
          <img
            src={member.image}
            alt={member.name}
            className={`
              w-full h-full object-cover transition-all duration-500
              ${isHovered ? 'brightness-110 scale-110' : 'brightness-100'}
            `}
          />
          <div
            className={`
              absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent
              opacity-0 transition-opacity duration-500
              ${isHovered ? 'opacity-100' : ''}
            `}
          />
        </div>

        <div className="p-6">
          <h3
            className={`
              font-bold text-[#2f4f2f] transition-all duration-300
              ${isHovered ? 'text-2xl mb-1' : 'text-xl mb-1'}
            `}
            style={{ fontFamily: "'Lora', serif" }}
          >
            {member.name}
          </h3>

          <p
            className={`
              text-sm font-medium text-[#228b22] mb-3 transition-all duration-300
              ${isHovered ? 'opacity-100' : 'opacity-80'}
            `}
            style={{ fontFamily: "'Lora', serif" }}
          >
            {member.role}
          </p>

          <div
            className={`
              overflow-hidden transition-all duration-500 ease-out
              ${isHovered ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}
            `}
          >
            <p
              className="text-sm leading-relaxed mb-4 break-words"
              style={{ 
                fontFamily: "'Times New Roman', Times, serif",
                lineHeight: '1.7'
              }}
            >
              {member.bio}
            </p>

            <div className="flex gap-3 justify-center flex-wrap">
              {member.email && (
                <a href={`mailto:${member.email}`} className="p-2 rounded-full bg-[#2f4f2f] text-white hover:bg-[#1a2f1a] transition" aria-label="Email">
                  <Mail className="w-4 h-4" />
                </a>
              )}
              {member.linkedin && (
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#0077b5] text-white hover:bg-[#005582] transition" aria-label="LinkedIn">
                  <Linkedin className="w-4 h-4" />
                </a>
              )}
              {member.phone && (
                <a href={`tel:${member.phone}`} className="p-2 rounded-full bg-[#228b22] text-white hover:bg-[#1a6b1a] transition" aria-label="Phone">
                  <Phone className="w-4 h-4" />
                </a>
              )}
              {member.website && (
                <a href={member.website} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#9acd32] text-[#2f4f2f] hover:bg-[#7fa828] transition" aria-label="Website">
                  <Globe className="w-4 h-4" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Card = ({ title, content, isHovered, onMouseEnter, onMouseLeave }) => {
  return (
    <div
      className={`
        bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-500 ease-in-out
        cursor-pointer
        ${isHovered ? 'scale-105 shadow-2xl' : 'hover:shadow-xl'}
      `}
      style={{ minHeight: isHovered ? 'auto' : '140px' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="p-8">
        <div className="mb-6">
          <h2
            className="text-xl font-medium tracking-[0.05em] uppercase"
            style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
          >
            {title}
          </h2>
        </div>

        <div
          className={`
            transition-all duration-500 ease-in-out overflow-hidden
            ${isHovered ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'}
          `}
        >
          <p 
            className="text-gray-700 leading-relaxed text-base break-words"
            style={{ 
              fontFamily: "'Times New Roman', Times, serif",
              lineHeight: '1.7'
            }}
          >
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};

const AboutUs = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredMember, setHoveredMember] = useState(null);

  const team = [
    {
      id: 'ceo',
      name: 'Mugabe Robert',
      role: 'CEO & Senior Travel Consultant',
      image: 'https://www.uganda-safaris-tours.com/ug/img/team/robert1.jpg',
      bio: 'With over 15 years in African safaris, Mugabe leads with passion and deep local knowledge. He personally joins select groups to ensure perfection.',
    },
    {
      id: 'global',
      name: 'Tobias Kimmich',
      role: 'Global Travel Expert, Germany',
      image: 'https://www.adventure-travellers.com/imgs/aat-images/tobias-kimmich-global-travel-expert-at-african-adventure-travellers.jpg',
      bio: 'Based in Germany, Tobias connects international travelers with authentic Tanzanian experiences. Fluent in 4 languages.',
    },
    {
      id: 'local',
      name: 'Barak Chuwa',
      role: 'Senior Travel Expert, Tanzania',
      image: '/Pale.jpg',
      bio: 'Born in Moshi, Barak knows every trail in Kilimanjaro and Serengeti. A certified safari guide with 12+ years of field expertise.',
    },
    {
      id: 'it',
      name: 'Dumba Bejamin',
      role: 'IT Manager',
      image: 'https://www.adventure-travellers.com/imgs/dumba.jpg',
      bio: 'Dumba ensures seamless booking systems and 24/7 digital support. He’s the tech backbone behind your smooth safari planning.',
    },
    {
      id: 'assistant',
      name: 'Namara Racheal',
      role: 'IT Assistant',
      image: 'https://www.adventure-travellers.com/imgs/WhatsApp%20Image%202025-09-26%20at%2015.34.39_963c5576.jpg',
      bio: 'Racheal supports clients with real-time updates, WhatsApp bookings, and instant responses. Always smiling, always helpful.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* HERO */}
      <div className="py-16 px-0 md:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 text-center">
            <h1
              className="text-5xl md:text-6xl font-bold mb-4"
              style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
            >
              TANZANIA YETU
            </h1>
            <p
              className="text-2xl md:text-3xl font-medium mb-6"
              style={{ color: '#228b22', fontFamily: "'Lora', serif" }}
            >
              OUR TANZANIA, YOUR ADVENTURE
            </p>
          </div>

          <div style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>
            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              Welcome to Tanzania Yetu, where "Yetu" means "ours" in Swahili. We believe Tanzania belongs to all of us – its breathtaking wildlife, majestic landscapes, rich cultures, and warm people. As your trusted tourism partner, we're passionate about sharing the authentic beauty and wonder of Tanzania with the world.
            </p>
          </div>
        </div>
      </div>

      {/* ABOUT US – AFRICAN ADVENTURE TRAVELLERS LTD */}
      <section className="py-8 px-6 md:px-12 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4 text-center uppercase"
            style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
          >
            ABOUT US – AFRICAN ADVENTURE TRAVELLERS LTD
          </h2>

          <p className="text-sm text-gray-600 text-center mb-6 italic" style={{ fontFamily: "'Lora', serif" }}>
            LICENSED BY THE GOVERNMENT OF UGANDA (MINISTRY OF TOURISM & TRADE) MEMBER OF AUTO – ASSOCIATION OF UGANDA TOUR OPERATORS
          </p>

          <div style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>
            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              African Adventure Travellers Ltd is a proudly Ugandan tour company offering authentic, high-quality, and affordable safaris across Uganda, Tanzania, and East Africa. We connect travellers with Africa’s wildlife, landscapes, and cultures through memorable and responsible travel experiences.
            </p>

            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              We specialize in custom safaris and adventures, including gorilla and chimp trekking, wildlife game drives, birding, hiking, cultural tours, and adventure activities such as rafting, kayaking, horseback riding, and fishing trips.
            </p>

            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              Our safaris extend to Zanzibar, featuring iconic destinations like the Serengeti, Ngorongoro Crater, Lake Manyara, and Zanzibar, offering travellers unforgettable encounters with wildlife and nature. Our mission is to provide personalized, safe, and sustainable journeys that leave lasting memories and showcase the true spirit of East Africa.
            </p>

            <h3
              className="text-2xl font-bold mt-8 mb-3 uppercase"
              style={{ color: '#228b22', fontFamily: "'Lora', serif" }}
            >
              OUR TEAM – THE HEART OF AFRICAN ADVENTURE TRAVELLERS
            </h3>

            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              At African Adventure Travellers Ltd, our strength lies in our dedicated and experienced team professionals who share a deep passion for wildlife, travel, and authentic African hospitality.
            </p>

            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              With years of experience in organizing successful safaris and tours, our travel consultants work closely with each client to design and customize itineraries that perfectly match their travel dreams, budget, and schedule. From your first inquiry to the end of your journey, you’ll be guided by experts who understand every corner of Uganda and East Africa.
            </p>

            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              Upon arrival, our Safari Representatives will warmly welcome you at the airport (or at your hotel/residence upon request), brief you about your safari, and ensure every detail is well-coordinated. Once your adventure begins, your personal driver-guide will accompany you throughout the trip, ensuring comfort, safety, and unforgettable memories on the road.
            </p>

            <p className="text-gray-700 leading-relaxed text-base md:text-lg mb-5">
              At African Adventure Travellers, your safety and satisfaction come first. Every team member, from the office to the field, is committed to delivering exceptional service and genuine care that makes you feel at home while exploring the wild. Our guides are fluent in English and at least possess knowledge of local languages across East Africa, enabling smooth communication with communities and enhancing the authenticity of every safari experience.
            </p>
          </div>
        </div>
      </section>

      {/* VISION, MISSION, VALUES */}
      <section className="pt-8 pb-16 px-0 md:px-12">
        <div className="max-w-6xl mx-auto">
          <h2
            className="text-4xl font-medium tracking-[0.05em] mb-6 text-center uppercase"
            style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
          >
            WHAT DRIVES US FORWARD
          </h2>

          <p className="text-lg text-gray-700 mb-6 px-6 md:px-0" style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>
            Our commitment to excellence in Tanzania's tourism industry is built on three pillars that guide everything we do.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-6 md:px-0">
            <Card
              title="OUR VISION"
              content="To be the leading destination management company in Tanzania, recognized globally for creating transformative safari and cultural experiences. We envision Tanzania as the world's premier eco-tourism destination, where conservation, community development, and authentic travel experiences converge to benefit both visitors and local communities for generations to come."
              isHovered={hoveredCard === 'vision'}
              onMouseEnter={() => setHoveredCard('vision')}
              onMouseLeave={() => setHoveredCard(null)}
            />
            <Card
              title="OUR MISSION"
              content="To showcase Tanzania's extraordinary wildlife, stunning landscapes, and vibrant cultures through carefully crafted, sustainable tourism experiences. We connect travelers with the soul of Tanzania while supporting conservation efforts, empowering local communities, and preserving our natural heritage. Every journey we create tells Tanzania's story with authenticity, respect, and wonder."
              isHovered={hoveredCard === 'mission'}
              onMouseEnter={() => setHoveredCard('mission')}
              onMouseLeave={() => setHoveredCard(null)}
            />
            <Card
              title="OUR CORE VALUES"
              content="Ubuntu (We are one) - fostering community connection; Mazingira (Environment) - protecting Tanzania's natural beauty; Utamaduni (Heritage) - celebrating local cultures; Ubora (Excellence) - delivering exceptional experiences; Uwazi (Transparency) - honest, ethical practices; Uongozi (Leadership) - pioneering sustainable tourism that benefits all stakeholders while creating memories that last a lifetime."
              isHovered={hoveredCard === 'values'}
              onMouseEnter={() => setHoveredCard('values')}
              onMouseLeave={() => setHoveredCard(null)}
            />
          </div>
        </div>
      </section>

      {/* TEAM SECTION */}
      <section className="py-12 px-6 md:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h3
            className="text-4xl font-medium tracking-[0.05em] mb-10 text-center uppercase"
            style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}
          >
            MEET OUR EXPERT TEAM
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
            {team.map((member) => (
              <TeamMember
                key={member.id}
                member={member}
                isHovered={hoveredMember === member.id}
                onHover={() => setHoveredMember(member.id)}
                onLeave={() => setHoveredMember(null)}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;